import { UserProfile } from "profile/types/profile";

export const API_URL = process.env.REACT_APP_API_BASE_URL;

export const profileAPI = {
  async CreateUserProfile(profile: UserProfile): Promise<UserProfile>{
    const response = await fetch(`${API_URL}/userprofiles`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profile),
    });

    if (!response.ok) {
      throw new Error("Failed to create user profile!");
    }

    const data: UserProfile = await response.json();
    return data;
  },

  async UpdateUserProfile(profile: UserProfile, slug: string): Promise<UserProfile> {
    const response = await fetch(`${API_URL}/userprofiles/${slug}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profile),
    });

    if (!response.ok) {
      throw new Error("Failed to update user profile!");
    }

    const data: UserProfile = await response.json();
    return data;
  },

  async getProfileByUser(slug: string) {
    const response = await fetch(`${API_URL}/userprofiles/${slug}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch user!");
    }

    return await response.json();
  },
};
